import { useState, useEffect, forwardRef } from 'react';
import './styles/styles.scss'
import Pages from './pages/pages/Pages';
import Fade from '@mui/material/Fade';
import MuiAlert from '@mui/material/Alert';
import { Snackbar } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { getCurrentDate } from './js/globalFunctions';
import SECHeader from './components/SECHeader/SECHeader';
import { isAuthorized } from './js/globalFunctions';
import ErrorPage from './components/ErrorPage/ErrorPage';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
  const {keycloak, initialized} = useKeycloak()
  const isViewAuthorized = isAuthorized(keycloak, 'react_page', 'service-core');

  const [createEnabled, setCreateEnabled] = useState(false)
  const [helpActive, setHelpActive] = useState(false)
  const [language, setLanguage] = useState('en');
  const [logMessages, setLogMessages] = useState([])
  const [logMessageState, setLogMessageState] = useState({
    open: false,
    Transition: Fade,
    vertical: 'bottom',
    horizontal: 'right',
    severity: 'success'
  });
  const {vertical, horizontal, severity} = logMessageState;

  /**
   * ***********************************************
   * hooks
   * ***********************************************
   */

  useEffect(() => {
    if (keycloak && initialized) {
      keycloak.onTokenExpired = () => keycloak.updateToken(60);
    }
    return () => {
      if (keycloak) keycloak.onTokenExpired = () => {};
    };    

  }, [keycloak, initialized])


  /**
   * ***********************************************
   * functions
   * ***********************************************
   */

  function addMessage(message, severity) {
    setLogMessages(prev => [...prev, [message, getCurrentDate()]])
    setLogMessageState(prev => {
      return {
        ...prev,
        open: true,
        severity: severity
      }
    });
  }

  function handleClose(event, reason){
    if (reason === 'clickaway') {
      return;
    }

    setLogMessageState(prev => {
      return {
        ...prev,
        open: false
      }
    });
  };

  function handleCreate(state){
    setCreateEnabled(state)
  }

  /**
   * ***********************************************
   * render
   * ***********************************************
   */

  return (
    <div className="app">
      <SECHeader handleCreate={handleCreate}/>

      {initialized && isViewAuthorized && <Pages 
        helpActive={helpActive} 
        createEnabled={createEnabled} 
        handleCreateEnabled={setCreateEnabled}
        addMessage={addMessage}
        language={language} />}

      {initialized && !isViewAuthorized && <ErrorPage status={401} message="Unauthorized" />}

        {/* Alerting (popup right bottom side) */}
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={logMessageState.open}
          onClose={handleClose}
          autoHideDuration={3000}
          TransitionComponent={logMessageState.Transition}
          key={logMessageState.Transition.name} >

          <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
            {logMessages.length > 0 && logMessages[logMessages.length-1][0]}
          </Alert>
        </Snackbar>

    </div>
  );
}

export default App;
